const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const DOB_YEARS_BACK = 120;

export function getTodayInputDate(now = new Date()): Date {
  return new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
}

export function getMonthStart(value: Date): Date {
  return new Date(value.getFullYear(), value.getMonth(), 1);
}

export function getDobOldestAllowedDate(referenceDate: Date): Date {
  return new Date(
    referenceDate.getFullYear() - DOB_YEARS_BACK,
    referenceDate.getMonth(),
    referenceDate.getDate(),
  );
}

export function getDobStartMonth(referenceDate: Date): Date {
  return getMonthStart(getDobOldestAllowedDate(referenceDate));
}

export function parseIsoDateInput(value: string): Date | undefined {
  const match = ISO_DATE_PATTERN.exec(value);

  if (!match) {
    return undefined;
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const parsedDate = new Date(year, month - 1, day);

  if (
    parsedDate.getFullYear() !== year ||
    parsedDate.getMonth() !== month - 1 ||
    parsedDate.getDate() !== day
  ) {
    return undefined;
  }

  return parsedDate;
}

export function formatDateInputValue(value: Date): string {
  return [
    String(value.getFullYear()).padStart(4, '0'),
    String(value.getMonth() + 1).padStart(2, '0'),
    String(value.getDate()).padStart(2, '0'),
  ].join('-');
}
